// src/pages/Twitter.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoTwitter,
    IoSparklesOutline, 
    IoChatbubblesOutline, 
    IoAnalyticsOutline, 
    IoFlashOutline 
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages2.png';
import image4 from '../assets/images/EngagementRate.png';
import heroBg from '../assets/images/twitter-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "X (Twitter) Management", "item": "https://oolook.in/twitter" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Twitter Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI X (Twitter) Management Tool", "description": "Manage your X (formerly Twitter) presence with Oolook. Use AI to generate viral threads and replies, schedule tweets, and track your performance.", "url": "https://oolook.in/twitter" };

const pageData = {
  seo: {
    title: "AI X (Twitter) Management Tool | Oolook",
    description: "Master the conversation on X (formerly Twitter). Oolook's AI helps you write viral threads, schedule tweets, monitor mentions, and analyze your engagement in real-time.",
    image: 'https://oolook.in/og/twitter.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoTwitter,
    title: "Dominate the Conversation on X",
    subtitle: "From viral threads to real-time engagement, Oolook gives you the AI-powered tools to grow your influence and stay ahead of the trend cycle on X (formerly Twitter).",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "Built for the Speed of Real-Time",
    subtitle: "Our X management tools are designed to help you move fast, stay relevant, and engage authentically.",
    features: [
      { title: "AI Thread & Tweet Generator", description: "Turn a single idea into a compelling, well-structured thread. Generate replies that are witty, on-brand, and context-aware.", image: image1 },
      { title: "Schedule Tweets & Threads", description: "Plan your content in advance. Write your threads and schedule them to be posted at the optimal time for visibility.", image: image2 },
      { title: "Real-Time Mention Tracking", description: "Our Unified Inbox brings all your mentions and replies into one feed, so you can join conversations as they happen.", image: image3 },
      { title: "Performance & Follower Analytics", description: "Track your key X metrics, including engagement rate, follower growth, and your most influential tweets.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Advantage of an AI-Powered X Strategy",
    benefits: [
      { icon: IoSparklesOutline, title: "Go Viral, Faster", description: "Use AI to craft content that captures attention and is optimized for the X algorithm." },
      { icon: IoFlashOutline, title: "Engage in Real-Time", description: "Stay on top of every conversation and build your reputation as a responsive, authoritative voice." },
      { icon: IoChatbubblesOutline, title: "Save Time Writing", description: "Eliminate writer's block. Generate high-quality drafts for tweets and threads in seconds." },
      { icon: IoAnalyticsOutline, title: "Understand Your Impact", description: "Use clear analytics to see which content is driving follower growth and engagement." }
    ]
  },
  // ✅ ADDED MISSING STEP-BY-STEP DATA
  stepByStep: {
    title: "Master the Art of the Tweet",
    subtitle: "A streamlined workflow for staying relevant and responsive on X.",
    steps: [
        { title: "1. Connect Your X Profile", description: "Securely link your X account to Oolook to sync your mentions and enable scheduling." },
        { title: "2. Generate a Viral Thread with AI", description: "Give the AI a topic, like '5 tips for better marketing', and watch it generate an entire, well-structured thread." },
        { title: "3. Schedule for Peak Times", description: "Add your new content to the calendar. Oolook's AI will suggest the best time to post for maximum visibility." },
        { title: "4. Monitor the Conversation", description: "As replies and mentions come in, manage them all from the Unified Inbox without leaving the platform." }
    ]
  },
  // ✅ ADDED MISSING TARGET AUDIENCE DATA
  targetAudience: {
    title: "The Essential Tool for Thought Leaders & Fast-Moving Brands"
  }
};

const Twitter = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default Twitter;